import { useContext } from 'react';
import Constants from '@usas/ui-web/utils/Constants';

import { OmeMeetOrgUnitEntryInfoStateContext } from './OmeMeetOrgUnitEntryInfoContextProvider';

import OmeMeetOrgUnitEntryInfoData from './OmeMeetOrgUnitEntryInfoData';

const useOmeMeetOrgUnitEntryInfoData = () => {
  const [omeMeetOrgUnitEntryInfoState, setOmeMeetOrgUnitEntryInfoState] = useContext(OmeMeetOrgUnitEntryInfoStateContext);

  const getOmeMeetOrgUnitEntryInfo = (omeMeetOrgUnitEntryId) => {
    OmeMeetOrgUnitEntryInfoData.getOmeMeetOrgUnitEntryInfoData(omeMeetOrgUnitEntryId, omeMeetOrgUnitEntryInfoState, setOmeMeetOrgUnitEntryInfoState);
  };

  const clearOmeMeetOrgUnitEntryInfoObjData = () => {
    setOmeMeetOrgUnitEntryInfoState({
      ...omeMeetOrgUnitEntryInfoState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      omeMeetOrgUnitEntryId: Constants.DEFAULT_ID,
      message: ''
    });
  };

  return {
    omeMeetOrgUnitEntryInfoState,
    setOmeMeetOrgUnitEntryInfoState,
    getOmeMeetOrgUnitEntryInfo,
    clearOmeMeetOrgUnitEntryInfoObjData
  };
};

export default useOmeMeetOrgUnitEntryInfoData;